import Vue from "vue";
import router from "@/router";
import VueAuthenticate from "vue-authenticate";

import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);

import Jsona from 'jsona';
const jsona = new Jsona();

const vueAuth = VueAuthenticate.factory(Vue.prototype.$http, {
  baseUrl: process.env.VUE_APP_API_BASE_URL,
  tokenName: "access_token",
  loginUrl: "/login",
  logoutUrl: "/logout",
  registerUrl: "/register"
});

export default {
  state: {
    isAuthenticated: localStorage.getItem("vue-authenticate.vueauth_access_token") !== null,
    authUser: null,
  },

  getters: {
    isAuthenticated(state) {
      return state.isAuthenticated;
    },
    permissions(state) {
      return state.authUser?.permissions || [];
    },
    roles(state) {
        return state.authUser?.roles?.map(r => r.name) || [];
    }
  },

  mutations: {
    isAuthenticated(state, payload) {
      state.isAuthenticated = payload.isAuthenticated;
    },
    setAuthUser(state, user) {
      state.authUser = user;
    }
  },

  actions: {
    async login(context, payload) {
      return vueAuth.login(payload.user, payload.requestOptions).then(async () => {
        context.commit("isAuthenticated", {
          isAuthenticated: vueAuth.isAuthenticated()
        });

        // get auth user data after login
        const res = await axios.get(`${process.env.VUE_APP_API_BASE_URL}/me?include=roles,person,person.contacts`);
        context.commit("setAuthUser", jsona.deserialize(res.data));

        router.push({name: "Home"});
      });
    },

    register(context, payload) {
      return vueAuth.register(payload.user, payload.requestOptions).then(response => {
        context.commit("isAuthenticated", {
          isAuthenticated: vueAuth.isAuthenticated()
        });
        router.push({name: "Home"});
      });
    },

    logout(context, payload) {
      return vueAuth.logout(payload.requestOptions)
        .catch(() => {
          // ignore errors during logout, e.g. network issues, token expired, etc.
        })
        .finally(() => {
          context.commit("isAuthenticated", {
            isAuthenticated: false
          });
          context.commit("setAuthUser", null);

          // delete token from localStorage to ensure user is logged out even if logout API call fails
          localStorage.removeItem("vue-authenticate.vueauth_access_token");

          router.push({ name: "Login" });
        });
      // return vueAuth.logout(payload.requestOptions).then(response => {
      //   context.commit("isAuthenticated", {
      //     isAuthenticated: vueAuth.isAuthenticated()
      //   });
      //   context.commit("setAuthUser", null);
      //   router.push({name: "Login"});
      // });
    }
  }
};
